export default {"src":"/_next/static/media/cart-bold-white.12f2d8cf.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};